import { Box, Grid, styled, SxProps, Theme } from '@mui/material';
import { PropsWithChildren } from 'react';

export interface PageLayoutProps {
  variant?: 'with-aside' | 'single';
  background?: 'paper';
  verticallyCenter?: boolean;
  sx?: SxProps<Theme>;
  dense?: boolean;
}

export default function PageLayout({ variant = 'single', children, background, verticallyCenter = false, dense = false }: PropsWithChildren<PageLayoutProps>) {
    if (variant === 'single') {
        return (
            <SingleContainer bgcolor={ background ? 'background.paper' : undefined }
                verticallyCenter={ verticallyCenter }
                dense={ dense }>
                { children }
            </SingleContainer>
        );
    }

    return (
        <WithAsideContainer container
            columnSpacing={ 5 }
            rowSpacing={ 3 }
            columns={{ xs: 1, md: 3 }}
            bgcolor={ background ? 'background.paper' : undefined }
            dense={ dense }
        >
            { children }
        </WithAsideContainer>
    );
}

const WithAsideContainer = styled(Grid, {
    shouldForwardProp: prop => prop !== 'dense'
})<{ dense: boolean }>(( { theme, dense } ) => ({
    ...(!dense && { 
        padding: theme.spacing(6)
    })
}));

const SingleContainer = styled(Box, {
    shouldForwardProp: prop => ![ 'verticallyCenter', 'dense' ].includes(prop as string)
})<{ verticallyCenter: boolean, dense: boolean }>(({ theme, dense, verticallyCenter }) => ({
    ...(!dense && { 
        padding: theme.spacing(6)
    }),
    ...(verticallyCenter ? {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    } : {}),
    flex: 1
}));
